/**
 * Shim for SvelteKit $app/* imports in widget builds
 * The widget always runs in a browser environment without SvelteKit routing
 */

// $app/environment
export const browser = true;
export const building = false;
export const dev = false;
export const version = '0.0.0';

// $app/state - minimal page state for widget
// Note: This is a plain object, not reactive, since this is just a shim
export const page = {
	url: typeof window !== 'undefined' ? new URL(window.location.href) : new URL('http://localhost'),
	params: {},
	route: { id: null },
	status: 200,
	error: null,
	data: {},
	form: undefined,
	state: {}
};

// $app/navigation - no-op functions for widget
export function goto() {
	console.warn('goto() not available in widget mode');
}

export function invalidate() {
	console.warn('invalidate() not available in widget mode');
}

export function invalidateAll() {
	console.warn('invalidateAll() not available in widget mode');
}

export function afterNavigate() {
	// No-op in widget
}

export function beforeNavigate() {
	// No-op in widget
}

// $env/static/public - widget receives URL via constructor, so this is just a fallback
export const PUBLIC_POCKETBASE_URL = 'https://api.botbakery.app';
